import http from '@/http';
import { normaliseMe } from '@/api/user.normaliser';

export async function fetchMe() {
  const res = await http.get('/api/AuthUser/me');
  return normaliseMe(res?.data || {});
}